module.exports = __webpack_public_path__ + "static/media/tachometer-fastest.d9733312.svg";